export default "__VITE_ASSET__Dq9d1bvM__"